export const environment = {
  production: true,
  appConfig: 'appconfig.production.json',
  appBaseUrl: 'https://medbooktest.norwelo.com',
  remoteServiceBaseUrl: 'https://medbookingtest-core.norwelo.com',
  localeMappings: [
    {
      "from": "pt-BR",
      "to": "pt"
    },
    {
      "from": "zh-CN",
      "to": "zh"
    },
    {
      "from": "he-IL",
      "to": "he"
    }
  ]
};
